export const businessIssuerRegistrationNumberRegex = /^[0-9]{13}$/;
export const businessIssuerRegistrationNumberPrefix = "T";
export const businessIssuerMaxSelectedGroupsCount = 100;
